import React from 'react';
import { motion } from 'framer-motion';

const SkeletonLoader = ({ variant = 'card', count = 1, className = '' }) => {
  const skeletons = Array.from({ length: count }, (_, i) => i);

  const variants = {
    card: (
      <div className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-2xl p-6 space-y-4">
        <div className="flex items-start justify-between">
          <div className="flex-1 space-y-3">
            <div className="h-6 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded-lg w-2/3 animate-pulse" />
            <div className="h-4 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded w-full animate-pulse" />
          </div>
          <div className="h-8 w-8 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded-lg animate-pulse" />
        </div>
        <div className="h-24 bg-gradient-to-r from-slate-800/50 to-slate-700/50 rounded-xl animate-pulse" />
        <div className="flex gap-2">
          <div className="h-6 w-16 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded-md animate-pulse" />
          <div className="h-6 w-20 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded-md animate-pulse" />
        </div>
        <div className="flex items-center justify-between">
          <div className="h-4 w-20 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded animate-pulse" />
          <div className="h-8 w-8 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded-lg animate-pulse" />
        </div>
      </div>
    ),
    list: (
      <div className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-xl p-4 flex items-center gap-4">
        <div className="h-4 w-4 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded animate-pulse" />
        <div className="flex-1 space-y-2">
          <div className="h-5 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded w-1/3 animate-pulse" />
          <div className="h-3 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded w-2/3 animate-pulse" />
        </div>
        <div className="flex gap-2">
          <div className="h-6 w-16 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded-md animate-pulse" />
          <div className="h-8 w-8 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded-lg animate-pulse" />
        </div>
      </div>
    ),
    stat: (
      <div className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-xl p-4">
        <div className="flex items-center justify-between">
          <div className="space-y-2 flex-1">
            <div className="h-4 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded w-1/2 animate-pulse" />
            <div className="h-8 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded w-1/3 animate-pulse" />
          </div>
          <div className="h-12 w-12 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded-xl animate-pulse" />
        </div>
      </div>
    ),
    text: (
      <div className="space-y-2">
        <div className="h-4 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded w-full animate-pulse" />
        <div className="h-4 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded w-5/6 animate-pulse" />
        <div className="h-4 bg-gradient-to-r from-slate-700/50 to-slate-600/50 rounded w-4/6 animate-pulse" />
      </div>
    )
  };

  return (
    <div className={className}>
      {skeletons.map((_, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: index * 0.1 }}
        >
          {variants[variant]}
        </motion.div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
